var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4303_1230)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4303_1230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1026 71.6921L31.6529 91.0414C30.1188 95.6436 24.4821 97.328 20.6746 94.322L4.89891 81.8676C1.95908 79.5466 0.78931 75.6321 1.97376 72.0787C3.18381 68.4486 6.58102 66 10.4075 66H46C42.4169 66 39.2357 68.2928 38.1026 71.6921Z",
    fill: "url(#paint0_linear_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1026 71.6921L31.6529 91.0414C30.1188 95.6436 24.4821 97.328 20.6746 94.322L4.89891 81.8676C1.95908 79.5466 0.78931 75.6321 1.97376 72.0787C3.18381 68.4486 6.58102 66 10.4075 66H46C42.4169 66 39.2357 68.2928 38.1026 71.6921Z",
    fill: "url(#paint1_radial_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3245 30H60.8335C74.7805 30 89.1466 40.0237 85.2858 51.5882L95.406 21.2744C98.1908 13.1151 89.4514 0 69.8184 0H30.3245C27.7419 0 25.4491 1.65259 24.6324 4.10265L18.6324 22.1026C17.3374 25.9878 20.2292 30 24.3245 30Z",
    fill: "url(#paint2_linear_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3245 30H60.8335C74.7805 30 89.1466 40.0237 85.2858 51.5882L95.406 21.2744C98.1908 13.1151 89.4514 0 69.8184 0H30.3245C27.7419 0 25.4491 1.65259 24.6324 4.10265L18.6324 22.1026C17.3374 25.9878 20.2292 30 24.3245 30Z",
    fill: "url(#paint3_linear_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8325 65.9999L11.2076 65.9999C6.9044 65.9999 3.08387 68.7528 1.72181 72.8344L11.7208 42.8376C13.0819 38.7542 16.9033 35.9999 21.2076 35.9999L69.8147 35.9999C83.2662 35.9999 92.6205 29.6694 95.5007 21.0261L85.2939 51.6972C82.952 58.6938 74.4997 65.9999 59.8325 65.9999Z",
    fill: "url(#paint4_linear_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8325 65.9999L11.2076 65.9999C6.9044 65.9999 3.08387 68.7528 1.72181 72.8344L11.7208 42.8376C13.0819 38.7542 16.9033 35.9999 21.2076 35.9999L69.8147 35.9999C83.2662 35.9999 92.6205 29.6694 95.5007 21.0261L85.2939 51.6972C82.952 58.6938 74.4997 65.9999 59.8325 65.9999Z",
    fill: "url(#paint5_linear_4303_1230)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4303_1230",
    x1: 3.99902,
    y1: 70,
    x2: 15.999,
    y2: 105.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#309C61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EC8B0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4303_1230",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4991 102) rotate(-90) scale(44 55.1631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.615451,
    stopColor: "#1E794A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E794A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4303_1230",
    x1: 30,
    y1: 12.5,
    x2: 90.4155,
    y2: 29.1851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20AC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568447,
    stopColor: "#1A7F7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024169"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4303_1230",
    x1: 60,
    y1: 1.00002,
    x2: 75.5,
    y2: 42.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A7F7C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588659,
    stopColor: "#004695",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003580"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4303_1230",
    x1: 16,
    y1: 40.9999,
    x2: 74,
    y2: 65.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76EB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179334,
    stopColor: "#52D17C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713946,
    stopColor: "#22918B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C74A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4303_1230",
    x1: 21,
    y1: 53.4999,
    x2: 11.5,
    y2: 49.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52D17C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0F098"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4303_1230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4303_1230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerPlatform);
export default __webpack_public_path__ + "static/media/power-platform.7d8bbd39f7fbca9aed7a128153e2c8a2.svg";
export { ForwardRef as ReactComponent };